import React, { useState, useEffect } from 'react'
import { Typography } from 'antd'

const { Text } = Typography

const TypingAnimation = ({
  text,
  speed = 30, // milliseconds per character
  onComplete,
  style = {}
}) => {
  const [displayedText, setDisplayedText] = useState('')
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isComplete, setIsComplete] = useState(false)

  // Strip HTML tags and convert to plain text
  const stripHtml = (html) => {
    const tmp = document.createElement('div')
    tmp.innerHTML = html
    return tmp.textContent || tmp.innerText || ''
  }

  const cleanText = stripHtml(text || '')

  useEffect(() => {
    if (!cleanText || currentIndex >= cleanText.length) {
      setIsComplete(true)
      if (onComplete) {
        onComplete()
      }
      return
    }

    const timer = setTimeout(() => {
      setDisplayedText((prev) => prev + cleanText[currentIndex])
      setCurrentIndex((prev) => prev + 1)
    }, speed)

    return () => clearTimeout(timer)
  }, [currentIndex, cleanText, speed, onComplete])

  // Reset when text changes
  useEffect(() => {
    setDisplayedText('')
    setCurrentIndex(0)
    setIsComplete(false)
  }, [text])

  return (
    <div className='typing-container' style={style}>
      {displayedText}
      {!isComplete && <span className='typing-cursor' />}
    </div>
  )
}

export default TypingAnimation
